/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decrease_TimecodeInputs */

const en_decrease_timecode = /** @type {(inputs: Decrease_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decrease timecode by 1.000/1.001`)
};

const fr_decrease_timecode = /** @type {(inputs: Decrease_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminuer le timecode de 1,000/1,001`)
};

const de_decrease_timecode = /** @type {(inputs: Decrease_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verringere den Timecode um 1,000/1,001`)
};

const it_decrease_timecode = /** @type {(inputs: Decrease_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminuisci il timecode di 1.000/1.001`)
};

const ru_decrease_timecode = /** @type {(inputs: Decrease_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уменьшите временной код на 1.000/1.001`)
};

const es_decrease_timecode = /** @type {(inputs: Decrease_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disminuir el código de tiempo en 1.000/1.001`)
};

const zh_cn2_decrease_timecode = /** @type {(inputs: Decrease_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将时间码减少 1.000/1.001`)
};

const ja_decrease_timecode = /** @type {(inputs: Decrease_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードを1.000/1.001ずつ減らす`)
};

const hi_decrease_timecode = /** @type {(inputs: Decrease_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड को 1.000/1.001 से घटाएँ`)
};

const pt_pt2_decrease_timecode = /** @type {(inputs: Decrease_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminua o código de tempo em 1,000/1,001.`)
};

/**
* | output |
* | --- |
* | "Decrease timecode by 1.000/1.001" |
*
* @param {Decrease_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const decrease_timecode = /** @type {((inputs?: Decrease_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decrease_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_decrease_timecode(inputs)
	if (locale === "de") return de_decrease_timecode(inputs)
	if (locale === "it") return it_decrease_timecode(inputs)
	if (locale === "ru") return ru_decrease_timecode(inputs)
	if (locale === "es") return es_decrease_timecode(inputs)
	if (locale === "zh-CN") return zh_cn2_decrease_timecode(inputs)
	if (locale === "ja") return ja_decrease_timecode(inputs)
	if (locale === "hi") return hi_decrease_timecode(inputs)
	if (locale === "pt-PT") return pt_pt2_decrease_timecode(inputs)
	return en_decrease_timecode(inputs)
});